import React from 'react';
import './RosaG.css'; // Assuming you have a CSS file for styling
import { useNavigate } from 'react-router-dom';
import icon from './Images/Rosa G Icon.gif';



function Rosag() {
  const navigate = useNavigate(); 
  const userEmail=sessionStorage.getItem('userEmail');  

  const handleNavigate = () => {
    navigate('/Rosag_Setup');
  };

  const handleNavigate1 = () => {
    navigate('/Rosag_Sync');
  };
  
  if (!userEmail){
    navigate('/signin');
    return null;  
  }


  return (
    <div id="image-container">
      <img id="myimage" src={icon} alt="img" width="100" height="100" />
      <h2 className="center-heading" style={{ color: 'pink' }}>ROSA-G Main Page</h2><br />
        <br />
        <br />
       

       <p>Signed in as:{userEmail}</p>

      <div className="app">
<div className="button-container">
  <input
    style={{
      backgroundColor: 'pink',
      marginTop: '10px',
      padding: '10px 20px',
      borderRadius: '5px',
      border: 'none',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '200px',
      textAlign: 'center',
    }}
    type="button"
    value="Sync"
    onClick={handleNavigate1}
  />

  <input
    style={{
      backgroundColor: 'pink',
      marginTop: '10px',
      padding: '10px 20px',
      borderRadius: '5px',
      border: 'none',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '200px',
      textAlign: 'center',
    }}
    type="button"
    value="Setup"
    onClick={handleNavigate}
  />
</div>
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
<br />
      <br />
<br />
      <br />
        <br />
        <br />
        <br />
        <br />

          <footer className="footer-section">
        <div className="container-4">
          <div className="nav-items"></div>
          <div className="text-6">&copy; 2022 HYDAX Pvt. Ltd. All rights reserved.</div>
        </div>
      </footer>

    </div>
  );
}

export default Rosag;

